import { organizationQueryKey } from '@cast/constants';
import { NodeResourceOffering } from '@cast/types';

import {
  configurationTemplateNameCriterion,
  configurationTemplateVersionCriterion,
  nodeListId,
  nodePoolCriterion,
  resourceOfferingCriterion,
  selectionTemplateNameCriterion,
  selectionTemplateVersionCriterion,
  nodeIdCriterion,
  annotationsCriterion,
  regionCriterion,
  nodeNameCriterion,
  labelsCriterion,
} from '../NodeList/constants';

import { makeSearchQuery } from '@cast/shared-search-ui';

type Template = {
  name: string;
  version?: string;
};

type Search = {
  orgId?: string;
  filterByPricing?: `${NodeResourceOffering}`[];
  nodeIds?: string[];
  nodeNames?: string[];
  nodePoolNames?: string[];
  regions?: string[];
  annotations?: string[];
  labels?: string[];
  filterBySelectionTemplate?: Template;
  filterByConfigTemplate?: Template;
};

export const makeNodeListLink = (clusterId: string, search?: Search) => {
  const link = `/external-clusters/${clusterId}/nodes`;
  if (search && Object.keys(search).length) {
    const values: Record<string, any> = {};
    if (search.orgId) {
      values[organizationQueryKey] = search.orgId;
    }
    if (search.filterByPricing) {
      values[resourceOfferingCriterion.key] = search.filterByPricing;
    }
    if (search.filterBySelectionTemplate) {
      values[selectionTemplateNameCriterion.key] =
        search.filterBySelectionTemplate.name;
      values[selectionTemplateVersionCriterion.key] =
        search.filterBySelectionTemplate.version;
    }
    if (search.filterByConfigTemplate) {
      values[configurationTemplateNameCriterion.key] =
        search.filterByConfigTemplate.name;
      values[configurationTemplateVersionCriterion.key] =
        search.filterByConfigTemplate.version;
    }
    if (search.nodeIds) {
      values[nodeIdCriterion.key] = search.nodeIds;
    }
    if (search.nodeNames) {
      values[nodeNameCriterion.key] = search.nodeNames;
    }
    if (search.nodePoolNames) {
      values[nodePoolCriterion.key] = search.nodePoolNames;
    }
    if (search.annotations) {
      values[annotationsCriterion.key] = search.annotations;
    }
    if (search.regions) {
      values[regionCriterion.key] = search.regions;
    }
    if (search.labels) {
      values[labelsCriterion.key] = search.labels;
    }
    return `${link}?${makeSearchQuery({ id: nodeListId, values })}`;
  }
  return link;
};
